module.exports = __webpack_public_path__ + "static/media/ruby.7f52234e.jpeg";